export const SLOT_SYMBOLS = ["🍒", "💎", "⭐", "🎁", "7️⃣", "🍋"] as const;

export type SlotSymbol = (typeof SLOT_SYMBOLS)[number];

export const JACKPOT_SYMBOL: SlotSymbol = "7️⃣";

export const SYMBOL_HEIGHT_PX = 96;

export const REEL_COUNT = 3;

/** Base spin duration before reel 1 begins stopping (ms) */
export const BASE_SPIN_MS = 1800;

/** Additional delay per reel index when stopping (ms) */
export const REEL_STOP_STAGGER_MS = 700;

export interface SpinOutcome {
  result: SlotSymbol[];
  isWin: boolean;
  isJackpot: boolean;
  winningSymbol: SlotSymbol | null;
}

export interface SlotMachineProps {
  className?: string;
  onSpinComplete?: (outcome: SpinOutcome) => void;
}
